import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { Selectable } from '@hakimo-ui/shared/ui-base';

export function useEmployeesByName() {
  const httpClient = useHttpClient();

  return (name: string, tenantId: string) => {
    const url = `/v2/orm/employee/names?name=${name}&tenant_id=${tenantId}`;

    return httpClient<Selectable[]>(url, {
      responseModifier: async (res) => {
        const respJson = await res.json();
        return respJson.payload;
      },
    });
  };
}

export default useEmployeesByName;
